import React, { Component } from 'react';
import APInput from './APInput';

class APMultilineInput extends Component {
  render() {
    return (
      <APInput
        multiline
        rows={4}
        {...this.props}
      />
    );
  }
}

export default APMultilineInput;
